import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

const endpoint: string = environment.apiUrl;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

interface PropertyUserPermission { 
  id: string,
  name: string,
  email: string,
  is_viewer: boolean,
  is_editor: boolean,
  can_toggle_permission: boolean,
};

@Injectable({
  providedIn: 'root',
})
export class PropertyUserPermissionService {
    private http = inject(HttpClient);

    getCompanyUsers(propertyListingId: number, moduleIdentifier: number): Observable<PropertyUserPermission> {
        return this.http.get<PropertyUserPermission>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/${moduleIdentifier}/list`, httpOptions);
    }
  
    togglePermission(propertyListingId: number, userId: number, moduleIdentifier: number, field: string): Observable<{ success: boolean }> {
      return this.http.put<{ success: boolean }>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/toggle`, { propertyListingId, userId, moduleIdentifier, field }, httpOptions);
    }

    getCreatorforPropertyListingModule(propertyListingId : number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/creator`, httpOptions);
    }

    getViewerByPropertyListingModulePermission(propertyListingId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/${moduleIdentifier}/viewers`, httpOptions);
    }
  
    getEditorByPropertyListingModulePermission(propertyListingId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/${moduleIdentifier}/editors`, httpOptions);
    }

    getViewersCountGroupedByModules(): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/getViewersCountGroupedByModules`, httpOptions);
    }

    userIsModuleEditorCheck(moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${moduleIdentifier}/userIsModuleEditorCheck`, httpOptions);
    }

    hasViewerPermission(propertyListingId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/${moduleIdentifier}/hasViewerPermission`, httpOptions);
    }

    hasEditorPermission(propertyListingId : number, moduleIdentifier: number): Observable<any> {
      return this.http.get<any>(`${endpoint}/api/propertyx/property-listings/${propertyListingId}/user-permissions/${moduleIdentifier}/hasEditorPermission`, httpOptions);
    }
}